import React from 'react';
import SEO from '../components/SEO';
import Header from "../partials/header/Header";
import Breadcrumb from '../container/Breadcrumb/Breadcrumb';
import AboutFour from '../container/About/AboutFour';
import Video from '../container/Video/Video';
import AboutFive from '../container/About/AboutFive';
import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import CallToActionTwo from '../container/CallToAction/CallToActionTwo';
import Footer from '../container/Footer/Footer';
import ScrollToTop from '../components/ScrollToTop.jsx';
import data1 from '../data/content/aboutFourContent';
import data2 from '../data/content/aboutFiveContent';
import CallToActionThree from "../container/CallToAction/CallToActionThree";
import {useLocation} from "react-router-dom";
import data3 from "../data/SEO/seoData";

const AIMLService = () => {
    const currentPage = useLocation();
    let seo_data = data3.filter(dataObj => dataObj.path === currentPage.pathname);
    return (
        <React.Fragment>
            <SEO title={seo_data[0].metaTitle} URL={seo_data[0].path} description={seo_data[0].metaDesc} />
            <Header />
            <Breadcrumb
                image={seo_data[0].bcEleImage}
                title={seo_data[0].bcEleTitle}
                content="Home"
                contentTwo="AI / ML Service"
            />
            <AboutFour
                mainContent={data1.aiAndMl.mainContent} mainContent2={data1.aiAndMl.mainContent2}
                subTitle={data1.aiAndMl.subTitle}
                title={data1.aiAndMl.title}
                backgroundImg={data1.aiAndMl.backgroundImg} foregroundImg={data1.aiAndMl.foregroundImg}
            />
            <Video content="Building Smarter Businesses Today" />
            <AboutFive
                mainContent={data2.aiAndMl.mainContent} mainContent2={data1.aiAndMl.mainContent2}
                subTitle={data2.aiAndMl.subTitle}
                title={data2.aiAndMl.title}
                backgroundImg={data2.aiAndMl.backgroundImg} foregroundImg={data2.aiAndMl.foregroundImg}
            />
            {/*<TestimonialContainer classOption="bg-primary-blue" />*/}
            <CallToActionThree titleContent="Experience the Transformative Power of AI Without Compromise" />
            <Footer />
            <ScrollToTop />
        </React.Fragment>
    )
}

export default AIMLService;



